module.exports = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text;
  if (!text || String(text).trim() === '') {
    return '';
  }
  return "<div class=\"body\">".concat(text, "</div>");
};